import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Loader from '../../Loader';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class SetTimeTable extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			cls: '',
			section: '',
			subject: '',
			teacher: '',
			day: '',
			hour: '',
			_message: '',
			alertClass: '',
			posts: [],
			secs: [],
			teach: [],
			data: [],
			issubsel: false,
			accyear: [],
			_redirect: false,
			modal: false,
			alsec: [],
			subj: [],
			alldata: [{ "day": '', "hour": '', "sub": '', "teach": '' }]
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onSelectChange = this.onSelectChange.bind(this);
		this.onSubSelectChange = this.onSubSelectChange.bind(this);
		this.onStore = this.onStore.bind(this);
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	onStore(e) {

		this.state.alldata.push({ "day": this.state.day, "hour": this.state.hour, "sub": this.state.subject, "teach": this.state.teacher });
		this.toggle();
	}

	onSelectChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		//this.getteacher();
	}

	onSubSelectChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getteacher();
	}

	handleChange(id, e) {

		this.setState({
			modal: !this.state.modal
		});
		this.state.day = id;
		this.state.hour = e.target.value;
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		if (this.state.acyear != '' && this.state.cls != '') {

			this.gettimetab();
			this.getsubject();
		}
	}

	onClick() {

		document.getElementById("userform").reset();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('timetable/addtimetable', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				/* this.setState({
					_message:'Time Table Created Successfully!..',
					alertClass:'alert alert-success',
				}); */
				this.toggle();
				this.gettimetab();
				if (this.state.subject != '' && this.state.teacher != '') {
					alert('Time Table Created Successfully!..');
				}
				// document.getElementById("userform").reset();
			}
			else {

				this.setState({
					_message: 'Error!..',
					alertClass: 'alert alert-danger',
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('teacherallocation/deletedetails', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'ClassTeacherAllocation Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove ClassTeacherAllocation',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdate(dt) {

		this.state.idd = dt;
		this.setState({ _redirect: true });

	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getacyear();
	}


	getallsection() {

		var ac = this.state.acyear;
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					alsec: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	getacyear() {
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	checkteacher(emp){
		var bstate = false;
		var d = this.state.data;
		var index = d.findIndex(function(obj){
			return(obj.teacher == emp);
		});
		if(index > -1){
			bstate = emp;
		}
		console.log(emp);
		console.log(index);
		return bstate;
	}
	
	/** get Teacher **/
	getteacher() {
		var sr = $("#sub").val();
		var ar = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		this.setState({ issubsel: true });
		GetData('subjectallocation/getteabysub/' +ar+'/'+ sr + '/' + this.state.day + '/' + this.state.hour).then((result) => {
			this.setState({ issubsel: false });
			let responseJson = result;
			if (responseJson) {
				var dat = [];
				for(var i=0;i<responseJson.length;i++){
					var classes = responseJson[i].classes;
					var clsList = classes.split(',');
					if(clsList.length > 0){
						for(var j=0;j<clsList.length;j++){
							if(clsList[j] == cls){
								dat.push(responseJson[i]);
							}
						}
					}
				}
				var d = this.state.data;
				var dat1 = dat.filter(function(obj){
					var bstate = '';
					var index = d.findIndex(function(obj1){
						return(obj1.teacher == obj.employee);
					});
					if(index > -1){
						bstate = obj.employee;
					}
					return (obj.employee == bstate);
				})
				this.setState({
					teach: dat
				});
			}
		});
	}
	

	getsubject() {
		var fr = $("#year").val();
		var ar = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getsubbyclsbyname/' + fr + '/' + ar).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	gettimetab() {
		var ac = $("#year").val();
		var fr = $("#clas").val();
		var sr = $("#secs").val();
		$("#showLoader").show();
		GetData('timetable/gettimetable/' + ac + '/' + fr + '/' + sr).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	getperiod() {
		var period = [];

		for (var i = 1; i < 9; i++) {

			period.push(<td>{i}</td>);
		}

		return period;
	}

	getselect(dayid) {

		var btntd = [];

		for (var j = 1; j < 9; j++) {

			if (this.checkdata(dayid, j,'subname')) {

				btntd.push(<td><span id="tttext">{this.checkteadata(dayid, j)}</span><br></br><Button id="btn-tt" size="sm" className={this.checkdata(dayid, j,'subname')} value={j} onClick={this.handleChange.bind(this, dayid)}> {this.checkdata(dayid, j,'subname')}</Button>
					<br /><center id="tttext">{this.checkdata(dayid, j,'classtime')}</center>
				</td>);
			}
			else {

				btntd.push(<td><Button size="sm" color="primary" value={j} onClick={this.handleChange.bind(this, dayid)}> Select</Button></td>);
			}
		}
		return (btntd);
	}

	checkdata(days, hr, field) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].day == days && this.state.data[ii].hour == hr) {

				boolstate = this.state.data[ii][field];
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	checkteadata(days, hr) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].day == days && this.state.data[ii].hour == hr) {

				boolstate = this.state.data[ii].empname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	gethours() {

		var day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		var tabtd = [];

		for (var k = 1; k < 7; k++) {

			tabtd.push(<tr>
				<td>{day[k - 1]}</td>
				{this.getselect(day[k - 1])}
			</tr>);
		}
		return tabtd;
	}


	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/academic/editteacherallocate/' + this.state.idd} />);

		}

		var items = this.state.posts;
		var sub = this.state.subj;
		var tea = this.state.teach;
		var acyear = this.state.accyear;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '') {

			$("#teatable").show();
			$("#ttabbody").show();
		}
		else {

			$("#teatable").hide();
			$("#ttabbody").hide();
		}

		/** get Section By Class **/
		$("#clas").change(function () {
			var fr = $(this).val();
			var ar = $("#year").val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#secs").html('');
				$('#secs')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secs')
						.append($("<option></option>")
							.attr("value", value.id)
							.text(value.secs));

				});

			}, 'json');

		});

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Create Time Table</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
								<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>&nbsp;&nbsp;
									Class : &nbsp;&nbsp;
								<select name="cls" onChange={this.onChange} id="clas" required>
											<option value="">Select Class</option>
											{
												items.map(function (item) {
													return <option value={item.id}>{item.class}</option>;
												})
											}
										</select>&nbsp;&nbsp;
									Section : &nbsp;&nbsp;
								<select name="section" onChange={this.onChange} id="secs" required>

										</select>
									</CardHeader>
									<CardBody id="ttabbody">
										<Row>
											<Col md="12">
												<Table responsive bordered id="teatable">
													<thead>
														<tr>
															<td>#</td>
															{this.getperiod()}
														</tr>
													</thead>
													<tbody>
														{this.gethours()}
													</tbody>
												</Table>
											</Col>
											<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
												<ModalHeader toggle={this.toggle}>Select</ModalHeader>
												<ModalBody>
													<Row>
														<Col md="12">
															<FormGroup>
																<Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
																<select name="subject" onChange={this.onSubSelectChange} className="form-control" id="sub" required>
																	<option value="">Select Subject</option>
																	{
																		sub.map(function (item) {
																			return <option value={item.subject}>{item.sub}</option>;
																		})
																	}
																</select>
															</FormGroup>
														</Col>
														<Col md="12">
															<FormGroup>
																<Label htmlFor="name">Class Teacher <span className="text-danger">*</span></Label>
																{this.state.issubsel ? <Loader /> :
																	<select name="teacher" onChange={this.onSelectChange} className="form-control" id="teac" required>
																		<option value="">Select Teacher</option>
																		{
																			tea.map(function (item) {
																				return <option value={item.employee}>{item.empname} ({item.designation} - {item.department})</option>;
																			})
																		}
																	</select>
																}
															</FormGroup>
														</Col>
														<Col md="12">
															<FormGroup>
																<Label htmlFor="name">Time <span className="text-danger">*</span></Label>
																<input type="text" name="classtime" onChange={this.onSelectChange} className="form-control" required />
															</FormGroup>
														</Col>
													</Row>
												</ModalBody>
												<ModalFooter>
													<Button type="submit" color="primary" onClick={this.onSubmit}>Submit</Button>
													<Button color="secondary" onClick={this.toggle}>Cancel</Button>
												</ModalFooter>
											</Modal>
										</Row>
									</CardBody>
								</form>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default SetTimeTable;


// WEBPACK FOOTER //
// ./src/timetable/SetTimeTable/SetTimeTable.js